import Alerts from 'lib/alerts';
import Cocktail from 'lib/Cocktail';
import template from 'commons/templates/Leave.ejs';
import moment from 'moment';
import loader from 'helpers/loader';
import LeaveRequest,
    {consts as LeaveRequestConsts} from 'newModels/leave-request.js';
import PeriodPicker from 'commons/views/PeriodPicker';
import tooltip from 'helpers/tooltip';
import FormView from 'commons/views/Form';
import modal from "../../helpers/modal";

module.exports = Cocktail.mixin(FormView.extend({
    events: {
        'change .js-employee-select': 'changeEmployee',
        'change input[type="file"]': 'uploadFiles',
        'change .js-leave-type': 'setLeaveType',
        'change .js-details': 'setDetails',
        'click .js-cancel': 'cancel',
        'submit .js-form': 'submit',
        'change input,select,textarea': 'taint',
        'ifToggled input': 'taint'
    },

    initialize: function(options) {
        this.template = template;
        /* Mock */
        this.allowHalfDays = true;

        this.employees = options.employees;
        this._leaveTypes = options.leaveTypes;
        //this.attachments = options.attachments;
        //this.attachmentsHasChanged = false;
        //this.attachments.on('add', this.addAttachment, this);
        this.daysRequested = 0;
        this.files = [];

        this.leaveRequest = options.leaveRequest;
        if (typeof (this.leaveRequest.get('dateTo')) === 'undefined') {
            this.leaveRequest.set('dateTo', null);
        }
        this.model = this.leaveRequest;
        this._onInitializeSetLeaveRequest(options);

        FormView.prototype.initialize.apply(this, [this.options]);

        // if we're dealing with one employee
        if (this.employees.length === 1) {
            const employee = this.employees.at(0);
            this.filterEmployeeLeaveTypes(employee);
        }

        return this.render();
    },

    _onInitializeSetLeaveRequest: function() {
    },

    _renderTemplate: function() {
        return this.template({
            employees: this.employees,
            leaveTypes: this.leaveTypes,
            leaveRequest: this.leaveRequest,
            allowHalfDays: this.allowHalfDays,
            employeeChooser: ''
        });
    },

    render: function() {
        this.$el.html(this._renderTemplate());
        tooltip.init(this);

        this.$submit = this.$('.js-submit');
        this.$cancel = this.$('.js-cancel');

        this.$('.js-employee-select').chosen({width: '100%'});
        this.$('.js-leave-type').chosen({width: '100%'});

        if (this.leaveRequest.getEmployee()) {
            const employee = this.leaveRequest.getEmployee();
            this.leaveTypes = this._leaveTypes
                .filter(this.getEntitledDays(employee));

            this.$('.js-employee-select')
                .val(employee.id)
                .trigger('chosen:updated');
        }

        if (this.leaveRequest.getType()) {
            this.$('.js-leave-type')
                .val(this.leaveRequest.getType().id);
        }

        this.$('.input-daterange').datepicker({
            weekStart: 1,
            daysOfWeekDisabled: [0, 6],
            autoclose: true,
            format: 'dd/mm/yyyy',
            todayHighlight: true
        });

        this.$('.input-daterange input[name="from"]')
            .datepicker('setDate', this.leaveRequest.get('dateFrom'));
        this.$('.input-daterange input[name="to"]')
            .datepicker('setDate', this.leaveRequest.get('dateTo'));

        this.$('.js-attachments').html('');

        this.periodPicker = new PeriodPicker({
            el: this.$('.js-date'),
            allowHalfDays: true,
            dateFrom: this.leaveRequest.get('dateFrom'),
            dateFromType: this.leaveRequest.get('dateFromType'),
            dateTo: this.leaveRequest.get('dateTo'),
            dateToType: this.leaveRequest.get('dateToType'),
            daysOfWeekDisabled: []
        });
        this.periodPicker.on('change', data => {
            this.$('.js-save').removeClass('disabled');
            this.leaveRequest.set(data, {silent: true});
            this.updateButtonsState();
            this.toggleError('dateFrom');
            this.canLeaveRequestBeAdded();
        });

        //this.attachments.each(this.addAttachment, this);
        $(window).trigger('scroll');
        this.markMandatoryFields();
        this.rendered = true;
    },

    renderRequestedDays: function(daysRequested, daysAllowed) {
        const type = this.leaveRequest.getType();

        this.daysRequested = daysRequested;
        this.$('.js-requested-days-box')
            .toggleClass('col-sm-6', type.get('paid'))
            .toggleClass('col-sm-12', !type.get('paid'));
        this.$('.js-requested-days').text(daysRequested);
        this.$('.js-requested-days-label')
            .text((daysRequested === 1) ? 'day' : 'days');
        this.$('.js-allowed-days-box').toggle(type.get('paid'));

        if (!type.get('paid')) {
            this.$('.js-allowed-warning').hide();
        } else {
            this.$('.js-allowed-warning').toggle(daysRequested > daysAllowed);

            this.$('.js-allowed-days').text(daysAllowed);
            this.$('.js-allowed-days-label')
                .text((daysAllowed === 1) ? 'day' : 'days');
        }
    },

    changeEmployee: function(e) {
        const employeeId = this.$(e.currentTarget).val();
        const employee = this.employees.find(employee => {
            return employee.id === employeeId;
        });
        this.filterEmployeeLeaveTypes(employee);
        this.render();
    },

    filterEmployeeLeaveTypes: function(employee) {
        employee.company = app.company;
        this.leaveRequest.setEmployee(employee);
        this.canLeaveRequestBeAdded();

        this.leaveTypes = this._leaveTypes.filter(type =>
            !type.get('gender') || type.get('gender') ===
                employee.get('gender')
        );
        this.leaveTypes = this.leaveTypes
            .filter(this.getEntitledDays(employee));
    },

    setLeaveType: function() {
        this.toggleError('type');
        let id = this.$('.js-leave-type').val();
        if (!id) {
            return;
        }
        this.leaveRequest.set({typeId: id});
        this.canLeaveRequestBeAdded();
    },

    setDetails: function() {
        const text = this.$('.js-details').val();
        this.leaveRequest.set({reason: text}, {validate: false});
        this.updateButtonsState();
    },

    uploadFiles: function(e) {
        var files = $(e.currentTarget)[0].files;
        if (files.length === 0) {
            return false;
        }

        if (files[0].size <= (4 * 1024 * 1024)) {
            this.addAttachment(files[0]);
        } else {
            Alerts.show('error', {
                title: 'Error',
                text: 'You are trying to upload a file that is way too big.\n' +
                'Maximum file size allowed is 4MB.\n' +
                'Please re-upload a smaller file.'
            });
        }
    },

    addAttachment: function(file) {
        var self = this;
        this.files.push(file);
        var $attachments = self.$('.js-attachments');

        var $link = $('<span style="margin-right: 10px;">' +
                      '<i class="fa fa-file"></i> ' +
                      file.name + '</span>');

        var $close = $('<i class="fa fa-times"></i>');

        var $item = $link.append($close);
        $('<div class="file-label">').append($item);

        $close.on('click', function() {
            $item.remove();
            var index = self.files.indexOf(file);
            if (index > -1) {
                self.files.splice(index, 1);
            }
        });
        $attachments.append($item);
    },

    taint: function(ev) {
        var $el = this.$(ev.currentTarget);

        if (!this.rendered || $el.closest('.js-date').length) {
            return;
        }

        this.tainted = true;
    },

    cancel: function() {
        this.leaveRequest = new LeaveRequest({
            dateFromType: LeaveRequestConsts.DATE_TYPE_FULL_DAY,
            dateToType: LeaveRequestConsts.DATE_TYPE_FULL_DAY
        });
        this.attachmentsHasChanged = false;
        this.updateButtonsState();
        this.rendered = false;
        this.render();
    },

    submit: function(e) {
        let stopLoader = function() {};

        e.preventDefault();
        if (!this.model.isValid()) {
            this.invalid(this.model, {
                errors: this.model.validationError
            });
            return;
        }

        const employee = this.leaveRequest.getEmployee();
        if (!employee) {
            Alerts.show('error', {text: 'You need to select an employee'});
            return;
        }

        if (moment(this.leaveRequest.get('dateTo'))
                .isSame(this.leaveRequest.get('dateFrom')) ||
            !this.leaveRequest.get('dateTo')
            ) {
            /* NOTE: overlapping checking relies on dateTo being null when
             not used */
            this.leaveRequest.set('dateTo', null);
            this.leaveRequest.set('dateToType', null);
        }

        this._onSubmitSetLeaveRequest();

        stopLoader = loader.startFullScreen(this.$('.js-submit'));

        return this.leaveRequest.save()
            .then(() => {
                return Promise.join(
                    this.files.map(file => new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = ev => {
                            const base64 = ev.target.result.split(',')[1];
                            return this.leaveRequest
                                .createAttachment({
                                    file: base64,
                                    name: file.name,
                                    description: ''
                                })
                                .then(() => resolve(true))
                                .catch(err => reject(err));
                        };
                        reader.onerror = err => reject(err);
                        reader.readAsDataURL(file);
                    }))
                );
            })
            .then(() => {
                const dateNavigation = moment(this.leaveRequest.get('dateFrom'))
                    .format('DD-MM-YYYY');

                app.mainRouter.navigate('calendar/date/' + dateNavigation, {
                    trigger: true,
                    replace: true
                });

                if (app.user.get('role') === 'employee') {
                    Alerts.show('info', {
                        title: 'Leave Requested',
                        text:  'Your leave request has been sent for review'
                    });
                } else {
                    Alerts.show('success', {
                        title: 'Leave Approved',
                        text:  'The leave has been approved'
                    });
                }
            })
            .catch(err => {
                if (app.company.get('leaveRequestsRestricted')) {
                    modal.showError(`Leaves feature has been migrated to Jibble and is restricted on Payroll Panda`, false);
                } else {
                    Alerts.show('criticalError', err);
                }
            })
            .finally(() => stopLoader());
    },

    _onSubmitSetLeaveRequest: function() {
        // To be overridden
    },

    updateButtonsState: function() {
        if (!this.rendered) {
            return false;
        }

        var enabled = false;
        enabled = this.leaveRequest.hasChanged() ||
            this.attachmentsHasChanged;
        if (!this.canBeAdded) {
            enabled = false;
        }

        if (enabled) {
            this.$submit.attr('disabled', false);
            this.$submit.removeClass('disabled');
            this.$cancel.removeClass('disabled');
        } else {
            this.$submit.attr('disabled', true);
            this.$submit.addClass('disabled');
            this.$cancel.addClass('disabled');
        }
    },

    canLeaveRequestBeAdded: function() {
        this.canBeAdded = false;
        if (!this.leaveRequest.get('dateFrom')) {
            this.updateButtonsState();
            return;
        }

        if (!this.leaveRequest.get('typeId')) {
            this.updateButtonsState();
            return;
        }

        const startDate = moment(this.leaveRequest.get('dateFrom'));
        const endDate = moment(this.leaveRequest.get('dateTo') || new Date());

        if (endDate.diff(startDate, 'year') > 0) {
            return;
        }

        return this.leaveRequest.canBeAdded()
            .then(r => {
                const type = this.leaveRequest.getType();

                if (type.get('paid') !== true) {
                    return Promise.resolve(r);
                }

                return this.leaveRequest.fetchDaysAllowed()
                    .then(daysAllowed => {
                        r.daysAllowed = daysAllowed;
                        return r;
                    });
            })
            .then((result) => {
                this.canBeAdded = true;
                this.$('.js-days-error').hide();
                this.$('.js-payroll-error').hide();
                this.$('.js-days-warning').hide();

                this.renderRequestedDays(
                    result.daysRequired,
                    result.daysAllowed
                );

                if (result.status) {
                    if (result.reason === 'overlapping' && result.warning) {
                        this.$('.js-days-warning').show();
                    }
                } else if (!result.status) {
                    this.canBeAdded = false;
                    if (result.reason === 'overlapping') {
                        this.$('.js-days-error').show();
                    } else if (result.reason === 'payroll') {
                        this.$('.js-payroll-error').show();
                    }
                }
                this.updateButtonsState();
                return result;
            })
            .catch(err => {
                const errorMessage = err && err.response && err.response.data && err.response.data.error && err.response.data.error.message;
                if (typeof errorMessage === 'string') {
                    Alerts.show(
                        'error',
                        errorMessage
                    );
                } else {
                    Alerts.show(
                        'error',
                        `Couldn't determine the validity of the request due to a ` +
                        `server error. Please try again.`
                    );
                }
            });
    },

    getEntitledDays: employee => type => {
        const isCustom = !!type.get('companyId');

        const daysOf = employee.getDaysEntitled(type);

        return isCustom ? daysOf > 0 : true;
    }
}));



// WEBPACK FOOTER //
// ./app/commons/views/Leave.js